module.exports = __webpack_public_path__ + "img/salaryGrades.0478d7c1.svg";